import { z } from "zod";
import { OutsourcePayeeTypeSchema } from "./common";
import { EventOutsourceInstallmentSchema } from "./event-outsource-installments";

export const EventOutsourceStatusSchema = z.enum([
  "planned",
  "partially_paid",
  "paid",
  "cancelled",
]);
export type EventOutsourceStatus = z.infer<typeof EventOutsourceStatusSchema>;

export const EventOutsourceSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  outsourceId: z.string().nullable(),
  categoryId: z.string(),
  categorySlug: z.string().optional(),
  categoryName: z.string().optional(),
  payeeType: OutsourcePayeeTypeSchema,
  displayName: z.string(),
  contactName: z.string().nullable(),
  roleLabel: z.string().nullable(),
  deliverableSummary: z.string().nullable(),
  agreedAmount: z.number().int().positive(),
  paymentMode: z.enum(["lump_sum", "installments"]).default("lump_sum"),
  status: EventOutsourceStatusSchema,
  installments: z.array(EventOutsourceInstallmentSchema).optional(),
  linkedPayoutId: z.string().nullable(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  bankName: z.string().nullable(),
  bankAccount: z.string().nullable(),
  bankAccountName: z.string().nullable(),
  sortOrder: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type EventOutsourceDTO = z.infer<typeof EventOutsourceSchema>;

export const CreateEventOutsourceSchema = z.object({
  outsourceId: z.string().min(1).optional(),
  categoryId: z.string().min(1),
  payeeType: OutsourcePayeeTypeSchema,
  displayName: z.string().trim().min(1, "ຕ້ອງປ້ອນຊື່"),
  contactName: z.string().nullable().optional(),
  roleLabel: z.string().nullable().optional(),
  deliverableSummary: z.string().nullable().optional(),
  agreedAmount: z.number().int().positive("ຍອດຕ້ອງຫຼາຍກວ່າ 0"),
  phone: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  bankName: z.string().nullable().optional(),
  bankAccount: z.string().nullable().optional(),
  bankAccountName: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
});
export type CreateEventOutsourceDTO = z.infer<typeof CreateEventOutsourceSchema>;

export const UpdateEventOutsourceSchema = CreateEventOutsourceSchema.partial();
export type UpdateEventOutsourceDTO = z.infer<typeof UpdateEventOutsourceSchema>;

export const EventOutsourceParamSchema = z.object({
  eventId: z.string().min(1),
  rowId: z.string().min(1),
});
export type EventOutsourceParamDTO = z.infer<typeof EventOutsourceParamSchema>;

export const CreateOutsourcePayoutSchema = z.object({
  notes: z.string().trim().optional(),
  installmentId: z.string().min(1).optional(),
});
export type CreateOutsourcePayoutDTO = z.infer<
  typeof CreateOutsourcePayoutSchema
>;

export const BulkCreateEventOutsourcesFromStaffSchema = z.object({
  staffIds: z.array(z.string().min(1)).min(1, "ເລືອກຢ່າງໜ້ອຍ 1 Staff"),
  categoryId: z.string().min(1),
  agreedAmount: z.number().int().positive("ຍອດຕ້ອງຫຼາຍກວ່າ 0"),
  roleLabel: z.string().trim().nullable().optional(),
  deliverableSummary: z.string().trim().nullable().optional(),
});
export type BulkCreateEventOutsourcesFromStaffDTO = z.infer<
  typeof BulkCreateEventOutsourcesFromStaffSchema
>;

export const BulkCreateEventOutsourcesFromStaffResultSchema = z.object({
  created: z.array(EventOutsourceSchema),
  skipped: z.array(
    z.object({
      staffId: z.string(),
      code: z.string(),
      message: z.string(),
    }),
  ),
});
export type BulkCreateEventOutsourcesFromStaffResultDTO = z.infer<
  typeof BulkCreateEventOutsourcesFromStaffResultSchema
>;
